export default "__VITE_ASSET__CWfacCdZ__"